import React, { useState } from "react";
import { P_Props } from "./VideoResourceList.type";
import { VideoForm, CategoryForm } from "../../..";
import { FloatingButton, Loading, Notification, Pulse, CategoryCard1 } from "../../../../components";
import { CustomButton } from "../../../../components";
import { DeleteIcon, VideoFloatIcon, CategoryIcon } from "../../../../icons";
import InfiniteScroll from "react-infinite-scroller";
import {
  Dialog,
  InputAdornment,
  TextField,
  Grid,
  Divider,
  Popover,
  MenuItem,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { PriorityHigh as PriorityHighIcon, Search, Edit, Delete } from "@material-ui/icons";
import { CATEGORY_TYPES } from "../../../../../constants";
import { VideoStatus, VideoOutputModel, VIDEO_MODE, BlogCategoryApiOutputModel } from "../../../../../models";
import { VideoUploadUtil, ImageUtil } from "../../../../../utils";

const VideoResourceListPresenter: React.FC<P_Props> = (props) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [videoDelete, setVideoDelete] = useState<VideoOutputModel | undefined>();
  const [categoryDetele, setCategoryDetele] = useState<BlogCategoryApiOutputModel | undefined>();
  const [visibleDeleteCategoryModal, setVisibleDeleteCategoryModal] = useState<boolean>(false);
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  const toggleDeleteModal = (video) => {
    if (video) {
      setVideoDelete(video);
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const [categoryPopup, setCategoryPopup] = React.useState<{
    anchorEl: HTMLButtonElement | null;
    category: BlogCategoryApiOutputModel | null;
  }>({ anchorEl: null, category: null });

  const openCategoryPopup = (event: React.MouseEvent<HTMLButtonElement>, category: BlogCategoryApiOutputModel) => {
    setCategoryPopup({ anchorEl: event.currentTarget, category });
  };

  const closeCategoryPopup = () => {
    setCategoryPopup({ anchorEl: null, category: null });
  };

  const toggleDeleteCategoryModal = (cate) => {
    if (cate) {
      setCategoryDetele(cate);
    }
    setVisibleDeleteCategoryModal(!visibleDeleteCategoryModal);
  };

  const activeCategory = props.categories.find((cate) => cate.link === props.filter.categoryUrl);

  return (
    <>
      <div className="video-resource-listing">
        <div className="video-resource-listing__category">
          <div className="video-resource-listing__category__header">
            <div className="title">Category</div>
          </div>
          <div
            className={`blog-listing__category__item ${!activeCategory ? "active" : ""}`}
            onClick={() => {
              props.onChangeCategory("", "");
            }}
          >
            <div className="video-resource-listing__category__item__form">
              <div className="video-resource-listing__category__item__name">All Videos</div>
            </div>
          </div>
          <Divider style={{ width: "100%", margin: "1.6rem 0" }} />
          <div className="video-resource-listing__category__list">
            {props.categories.map((cate) => {
              const isActive = cate.link === activeCategory?.link;

              return (
                <CategoryCard1
                  key={cate.id}
                  name={cate.title}
                  onClick={() => {
                    props.onChangeCategory(cate.code, cate.link);
                  }}
                  picture={cate.id || undefined} //picture
                  selected={isActive}
                  onActionClick={(e) => {
                    openCategoryPopup(e, cate);
                  }}
                  buildPictureSrc={ImageUtil.buildBlogCategoryImgSrc}
                  isAvatar={false}
                />
              );
            })}
          </div>
        </div>

        <div
          className="video-resource-listing__content"
          style={{
            opacity: visibleFloatingBtn ? "0.25" : "1",
            pointerEvents: visibleFloatingBtn ? "none" : "auto",
          }}
        >
          <div className="video-resource-listing__content__header">
            <div className="video-resource-listing__content__header__title">
              {activeCategory?.title || "All Videos"}
            </div>
            <div className="video-resource-listing__content__header__actions">
              <div className="video-resource-listing__content__header__actions--search">
                <TextField
                  placeholder="Search by name"
                  variant="outlined"
                  className="search-input"
                  inputProps={{ className: "input" }}
                  InputProps={{
                    // style: { fontSize: "1.4rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search className="icon" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    props.onSearch(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="video-resource-listing__content__list">
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedAllVideo.loading && props.fetchedAllVideo.totalPages > props.fetchedAllVideo.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedAllVideo.data.length) && props.fetchedAllVideo.loading && <Loading />}
              <Grid container spacing={8} style={{ width: "100%" }}>
                {props.fetchedAllVideo.data.map((video) => {
                  return (
                    <Grid item xs={4} key={video.id}>
                      <div className="video-resource-listing__content__list__item">
                        <div className="video-resource-listing__content__list__thumbnail">
                          {video.video ? (
                            <video width="100%" height="264" controls>
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/mp4" />
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/ogg" />
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/webm" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <div className="video-resource-text">
                              <iframe
                                width="100%"
                                height="264"
                                src={video.linkVideo?.replace("youtu.be/", "youtube.com/embed/")}
                                title="Video upload"
                              ></iframe>
                            </div>
                          )}
                        </div>
                        <div className="video-resource-text video-listing__content__list__status">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={Boolean(video.status === VideoStatus.PUBLISH)}
                                className="app-switch-box"
                                onChange={(e) => {
                                  e.preventDefault();
                                  props.handleChangeStatus(video.code, video.status);
                                }}
                              />
                            }
                            label={
                              <div className="video-resource-text">
                                {Boolean(video.status === VideoStatus.PUBLISH) ? "Published" : "Not Publish"}
                              </div>
                            }
                          />
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div
                            className="video-resource-text video-resource-listing__content__list__name"
                            onClick={() => props.openVideoFormModal(video.code)}
                          >
                            <b>{video.title}</b>
                          </div>
                          <div className="video-resource-text video-resource-listing__content__list__actions">
                            <CustomButton
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                toggleDeleteModal(video);
                              }}
                              color={"transparent"}
                              item={
                                <span>
                                  <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                                </span>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
              {/* {Boolean(props.fetchedAllVideo.data.length) && props.fetchedAllVideo.loading && <Loading />} */}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => {
          toggleFloatingBtn();
        }}
        btns={[
          {
            color: "primary",
            title: "Video",
            icon: <VideoFloatIcon size={[25, 23]} color="white" />,
            onClick: (e) => {
              props.openVideoFormModal();
            },
          },
          {
            color: "purple",
            title: "Category",
            icon: <CategoryIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openCategoryForm();
            },
          },
        ]}
      />

      <Popover
        open={Boolean(categoryPopup.anchorEl)}
        anchorEl={categoryPopup.anchorEl}
        onClose={closeCategoryPopup}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            props.openCategoryForm(categoryPopup.category?.code || undefined);
            closeCategoryPopup();
          }}
          style={{ fontSize: "1.4rem" }}
        >
          <Edit style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            toggleDeleteCategoryModal(categoryPopup.category);
            closeCategoryPopup();
          }}
          style={{ color: "red", fontSize: "1.4rem" }}
        >
          <Delete style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Delete
        </MenuItem>
      </Popover>

      <Dialog open={props.visibleVideoForm} maxWidth="lg" fullWidth>
        <VideoForm
          categoryId={props.filter.categoryCode}
          type={VIDEO_MODE.RESOURCE}
          // languageId={props.visibleSolutionId}
          videoCode={props.visibleVideoCode}
          onCancel={() => {
            props.closeVideoFormModal();
          }}
          onComplete_Create={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      <Dialog maxWidth="lg" fullWidth open={props.visibleCategoryForm}>
        <CategoryForm
          categoryType={CATEGORY_TYPES.VIDEO}
          categoryCode={props.visibleCategoryId}
          onCancel={() => {
            props.closeCategoryForm();
            closeCategoryPopup();
          }}
          //initial={visibleCategoryForm.initData || undefined}
          onComplete_Create={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
          onComplete_Delete={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
        />
      </Dialog>

      {/* Delete warning modal */}
      <Notification
        visible={visibleDeleteModal}
        title="Delete Video"
        subTitle={`Are you sure you want to delete video “${videoDelete?.title}“? This action cannot be undone.`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="video-resource-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(videoDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="video-resource-listing__delete-modal__actions__confirm"
              onClick={async () => {
                toggleDeleteModal(videoDelete);
                if (videoDelete?.code) {
                  await props.onDeleteVideo(videoDelete.code);
                  await props.onCompleteDeleteVideo();
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Notification
        visible={visibleDeleteCategoryModal}
        title="Delete Category"
        subTitle={`Are you sure you want to delete category “${categoryDetele?.title}“? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
                if (categoryDetele?.code) props.onDeleteCategory(categoryDetele?.code);
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default VideoResourceListPresenter;
